import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useOrganizationContracts } from '@/hooks/useOrganizationContracts';
import { useActiveWidgetSlotConfiguration } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useIsLimitedAccessUser } from '@/pages/shared/hooks/useIsLimitedAccessUser';
import { useIsOrganizationMember } from '@/pages/shared/hooks/useIsOrganizationMember';

import { ComingSoon } from '../../../components/ComingSoon';
import { useMenuItems } from '../../../hooks/useMenuItems';
import { ContractsList } from './components/ContractsList';

export const ContractsPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();

  const isLimitedAccessUser = useIsLimitedAccessUser();
  const isOrganizationMember = useIsOrganizationMember();
  const hideContracts = isLimitedAccessUser || !isOrganizationMember;

  const widgetSlotsConfiguration = useActiveWidgetSlotConfiguration(
    DefaultWidgetNames.default_template_contracts,
    WidgetType.t_page,
  );

  const { data: contractsData } = useOrganizationContracts();

  const hasNoContracts = contractsData.count === 0;

  // Show ComingSoon if user doesn't have access OR if there are no contracts
  if (hideContracts || hasNoContracts) {
    return (
      <SignedInPageLayout
        items={menuItems}
        navBarProps={{
          title: t('navbar.contracts'),
        }}
      >
        <ComingSoon />
      </SignedInPageLayout>
    );
  }

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('navbar.contracts'),
      }}
    >
      <Stack spacing={10}>
        <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
        <ContractsList contracts={contractsData.results} totalContracts={contractsData.count} />
      </Stack>
    </SignedInPageLayout>
  );
};
